import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * 监听滚动状态的 composable
 * @param threshold 触发阈值，默认 4px
 * @returns 是否已滚动的响应式引用
 */
export function useScrollFlag(threshold = 4) {
  const isScrolled = ref(false)
  let ticking = false

  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        isScrolled.value = window.scrollY > threshold
        ticking = false
      })
      ticking = true
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    // 初始检查
    handleScroll()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll)
  })

  return isScrolled
}
